import { IHelperLinks } from './interfaces';

export const portfolios = {
  km: {
    v1: 'https://thehelpfultipper.com/portfolios/v1/kleamerkuri/',
    v2: 'https://thehelpfultipper.com/portfolios/v2/kleamerkuri/',
  },
};

export const categories: string[] = ['All', 'Enterprise', 'AI', 'Tools', 'Product'];

export const links: IHelperLinks = {
  linkedin: {
    url: 'https://www.linkedin.com/in/kmerkuri97',
    text: 'LinkedIn',
  },
  github: {
    url: 'https://github.com/thehelpfultipper/',
    text: 'GitHub',
  },
  codepen: {
    url: 'https://codepen.io/thehelpfultipper',
    text: 'CodePen',
  },
  blog: {
    url: 'https://thehelpfultipper.com/',
    text: 'Blog',
  },
  resources: {
    url: 'https://thehelpfultipper.com/resources/',
    text: 'Resources',
  },
};
